export default __webpack_public_path__ + "static/media/Freelancer.efcb1375.png";